// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateProductRegistration = (state, action) => action.data;

export default (state = getDefaultState().previousDeliveryDate, action) => {

    const actionTypes = {
        [actions.UPDATE_REGISTRATION_PREVIOUS_DELIVERY_DATE]: updateProductRegistration
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/product-registration/reducers/registration-previous-delivery-date.js